import {
  REQUEST_LIST_API,
  REQUEST_LIST_COUNT_API,
} from '../../../constants/api'
import { postApi } from '../../../utils/api'

export function getRequestBoardColumnItems(data) {
  return postApi({ data, endpoint: REQUEST_LIST_API })
}

export function getRequestBoardColumnCount(filters) {
  return postApi({ data: { filters }, endpoint: REQUEST_LIST_COUNT_API })
}
